/**
 * Picks which vendored fixture path to load. Pure (takes the path list and
 * a requested name, returns a path or undefined) so it's unit-testable
 * without going through `import.meta.glob`.
 */
export function selectFixturePath(paths: readonly string[], requested: string | null): string | undefined {
  if (requested) {
    const match = paths.find((p) => p === requested || p.endsWith(`/${requested}`));
    if (match) return match;
  }
  // Default: prefer the Brief §9 worked example (8,000/2,000 -> 80/20) since
  // it's the canonical documented scenario; else fall back to whatever
  // vendored fixture sorts first.
  const workedExample = paths.find((p) => p.includes('worked-example'));
  if (workedExample) return workedExample;
  return [...paths].sort()[0];
}
